import { Injectable } from '@angular/core';
import { MutationUpdaterFn, WatchQueryFetchPolicy } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';

import { QueryResult } from '../query-result';

import { AdministratorDataService } from './administrator-data.service';
import { AuthDataService } from './auth-data.service';
import { BaseDataService } from './base-data.service';
import { ClientDataService } from './client-data.service';
import { CollectionDataService } from './collection-data.service';
import { CustomerDataService } from './customer-data.service';
import { FacetDataService } from './facet-data.service';
import { OrderDataService } from './order-data.service';
import { ProductDataService } from './product-data.service';
import { PromotionDataService } from './promotion-data.service';
import { SettingsDataService } from './settings-data.service';
import { ShippingMethodDataService } from './shipping-method-data.service';

@Injectable()
export class DataService {
  promotion: PromotionDataService;
  administrator: AdministratorDataService;
  auth: AuthDataService;
  collection: CollectionDataService;
  product: ProductDataService;
  client: ClientDataService;
  facet: FacetDataService;
  order: OrderDataService;
  settings: SettingsDataService;
  customer: CustomerDataService;
  shippingMethod: ShippingMethodDataService;

  constructor(private baseDataService: BaseDataService, apollo: Apollo) {
    this.promotion = new PromotionDataService(baseDataService);
    this.administrator = new AdministratorDataService(baseDataService);
    this.auth = new AuthDataService(baseDataService, apollo);
    this.collection = new CollectionDataService(baseDataService, apollo);
    this.product = new ProductDataService(baseDataService, apollo);
    this.client = new ClientDataService(baseDataService, apollo);
    this.facet = new FacetDataService(baseDataService);
    this.order = new OrderDataService(baseDataService, apollo);
    this.settings = new SettingsDataService(baseDataService);
    this.customer = new CustomerDataService(baseDataService);
    this.shippingMethod = new ShippingMethodDataService(baseDataService);
  }

  /**
   * Perform a GraphQL query.
   */
  query<T, V = Record<string, any>>(query: DocumentNode, variables?: V, fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network'): QueryResult<T, V> {
    return this.baseDataService.query(query, variables, fetchPolicy);
  }

  /**
   * Perform a GraphQL mutation.
   */
  mutate<T, V = Record<string, any>>(mutation: DocumentNode, variables?: V, update?: MutationUpdaterFn<T>): Observable<T> {
    return this.baseDataService.mutate(mutation, variables, update);
  }
}
